var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Drawer from '@material-ui/core/Drawer';
import React from 'react';
import { Subject } from 'rxjs';
import { PageType } from './api';
import Detail from './components/Detail';
import Grid from './components/Grid';
import { ApplicationContext } from './context';
import { renderDynamicComponent } from './render';
import { resolveData } from './services/actions';
import { Container } from './services/di';
import MultiDetail from './components/MultiDetail';
var MainPage = /** @class */ (function (_super) {
    __extends(MainPage, _super);
    function MainPage(props, ctx) {
        var _this = _super.call(this, props, ctx) || this;
        _this.pageDataState = Container.createDataStateService();
        _this.state = {
            loading: true,
            detailOpen: false,
            activeItem: null,
            selectedItemIds: []
        };
        return _this;
    }
    MainPage.prototype.componentDidMount = function () {
        this.pageDataState.addVariable('$params', this.props.routeMatch.params);
        this.refreshData();
    };
    MainPage.prototype.refreshData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.props.page.resolve) return [3 /*break*/, 2];
                        return [4 /*yield*/, resolveData(this.props.page.resolve, this.pageDataState, {
                                params: this.props.routeMatch.params,
                                query: {}
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.setState({
                            loading: false
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    MainPage.prototype.render = function () {
        var _this = this;
        var _a, _b;
        if (this.state.loading) {
            return React.createElement("div", null, "Loading");
        }
        // const menu = <Menu mode="horizontal">
        // 	{Container.applicationSetup.menus
        // 		.map((menuItem, index) => this._renderMenu(index, menuItem))}
        // </Menu>;
        var pageContent;
        if (this.props.page.type == PageType.SplitScreen) {
            var grid = React.createElement(Grid, { control: this.props.page.children[0], onActiveRow: function (item) { return _this.setState({ activeItem: item }); }, dataState: this.pageDataState, selectedIds: this.state.selectedItemIds, onSelectionChange: function (ids) { return _this.setState({ selectedItemIds: ids }); } });
            var detail = void 0;
            if (((_a = this.state.selectedItemIds) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                detail = React.createElement(MultiDetail, { actions: this.props.page.children[0].multiActions, modelName: this.props.page.children[0].modelName, ids: this.state.selectedItemIds, onCancel: function () { return _this.setState({ selectedItemIds: [] }); } });
            }
            else if (this.state.activeItem) {
                detail = React.createElement(Detail, { control: this.props.page.children[1], recordId: this.state.activeItem.id, onClose: function () { return _this.setState({ activeItem: null }); } });
            }
            var applicationContext = {
                broadcast: new Subject()
            };
            pageContent = React.createElement("div", null,
                React.createElement(ApplicationContext.Provider, { value: applicationContext },
                    grid,
                    React.createElement(Drawer, { style: { position: 'relative' }, ModalProps: {
                            hideBackdrop: true,
                            keepMounted: true,
                            disablePortal: true
                        }, anchor: "right", open: this.state.activeItem != null || ((_b = this.state.selectedItemIds) === null || _b === void 0 ? void 0 : _b.length) > 0, onClose: function () { return _this.setState({ detailOpen: false }); } }, detail)));
        }
        else if (this.props.page.type == PageType.Default) {
            pageContent = this.props.page.children
                .map(function (control, index) { return renderDynamicComponent(index, control, _this.pageDataState); });
        }
        else if (this.props.page.type == PageType.MobileScreen) {
            pageContent = this.props.page.children
                .map(function (control, index) { return renderDynamicComponent(index, control, _this.pageDataState); });
        }
        return React.createElement(React.Fragment, null, pageContent);
    };
    MainPage.contextType = ApplicationContext;
    return MainPage;
}(React.Component));
export default MainPage;
//# sourceMappingURL=MainPage.js.map